<template>
  <ServiceModeDialog v-if="showModeDialog" @confirmed="onModeConfirmed" />
  <router-view v-else-if="modeConfirmed" />
  <div v-else class="loading-screen">
    <p>{{ loadingText }}</p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import ServiceModeDialog from '@/components/ServiceModeDialog.vue';
import { useServiceModeStore } from '@/store/service-mode';

const showModeDialog = ref(false);
const modeConfirmed = ref(false);
const loadingText = ref('加载中...');
const store = useServiceModeStore();

function isTauriEnv(): boolean {
  return '__TAURI_INTERNALS__' in window;
}

onMounted(async () => {
  if (isTauriEnv()) {
    loadingText.value = '正在初始化...';
    try {
      const { getCurrentWindow } = await import('@tauri-apps/api/window');
      await getCurrentWindow().show();
    } catch (e) {
      console.warn('Failed to show window:', e);
    }
    try {
      await store.loadConfig();
      store.listenSidecarEvents();
    } catch (e) {
      console.error('Failed to load service mode config:', e);
    }
    // After redirect from local mode, frontend is served by backend — skip dialog
    if (store.mode === 'local' && window.location.href.startsWith(`http://localhost:${store.localPort}`)) {
      modeConfirmed.value = true;
    } else {
      showModeDialog.value = true;
    }
  } else {
    modeConfirmed.value = true;
  }
});

async function onModeConfirmed() {
  showModeDialog.value = false;
  modeConfirmed.value = true;
}
</script>

<style scoped>
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  color: #909399;
  font-size: 16px;
}
</style>
